module.exports = __webpack_public_path__ + "fca446c4cce3abdca1d77b4012b353aa.woff2";